import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setSearch as setSearchAction } from '@src/store/ui/actions';
import { searchSelector } from '@src/store/ui/selectors';

const useSearch = () => {
  const dispatcher = useDispatch();
  const search = useSelector(searchSelector);
  const setSearch = React.useCallback(
    (q: string) => {
      dispatcher(setSearchAction(q));
    },
    [dispatcher]
  );
  return React.useMemo(() => ({ search, setSearch }), [search, setSearch]);
};

export default useSearch;
